<template>
  <div class="main">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @cell-click="cellClick"
      >
        <el-table-column prop="username" label="公司账号" align="center"></el-table-column>
        <el-table-column prop="company_name" label="'公司名称" align="center"></el-table-column>
        <el-table-column prop="city_name" label="公司所在地" align="center"></el-table-column>
        <el-table-column prop="jd_name" label="职位名称" align="center"></el-table-column>
        <el-table-column prop="phone" label="简历手机号" align="center"></el-table-column>
        <el-table-column prop="weixin_nickname" label="微信姓名" align="center"></el-table-column>
        <el-table-column prop="weixin_gender" label="微信性别" align="center"></el-table-column>
        <el-table-column prop="weixin_place" label="微信地区" align="center"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { require } from '@/utils/http_request.js'
// import { delete } from "vue/types/umd";

export default {
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  created() {
    this.list()
  },

  methods: {
    cellClick(row) {
      console.log(row)
      if (row.city_radar_count != 0) {
      } else {
        this.$message.error('该城市线索为空')
      }
    },

    goPage() {
      this.$router.go(-1)
    },
    list() {
      let obj = {}
      let url = '/hr24_index_data/v1/province_radar_data/'
      require('post', url, obj).then((res) => {
        if (!res.code) {
          console.log(res)
          res.data.map((item) => {
            console.log(this.$route.query.src,"采集设备撒谎比")
            if (item.city_name == this.$route.query.src) {
              this.tableData = item.radar_info
            }
          })
          // this.loading = false
          // this.title = res.data.title
        } else {
        }
      })
    },
  },
}
</script>

<style scoped>
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/index/rader_C.vue